"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MACAddress = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
let MACAddress = class MACAddress {
    constructor(buffer) {
        this._raw = buffer;
    }
    static fromBuffer(buffer) {
        return new this(buffer);
    }
    static fromString(address) {
        return new this(Uint8Array.from(address
            .replace(/:/g, '')
            .split(/(..)/)
            .filter((a) => {
            return a !== '';
        })
            .map((hex) => {
            return Number(`0x${hex}`);
        })));
    }
    toBuffer() {
        return this._raw;
    }
    toString() {
        const bytes = [];
        for (const [, value] of this._raw.entries()) {
            bytes.push(value);
        }
        return bytes
            .map((byte) => {
            return byte.toString(16).padStart(2, '0');
        })
            .join(':');
    }
};
exports.MACAddress = MACAddress;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Uint8Array)
], MACAddress.prototype, "_raw", void 0);
exports.MACAddress = MACAddress = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [Uint8Array])
], MACAddress);
//# sourceMappingURL=MACAddress.js.map